interface ulnaDataType {
  [ulnaLength: number]: {
    lessThan65: number;
    greaterThan65: number;
  };
}

const ulnaData: { male: ulnaDataType; female: ulnaDataType } = {
  male: {
    32: {
      lessThan65: 1.94,
      greaterThan65: 1.87
    },
    31.5: {
      lessThan65: 1.93,
      greaterThan65: 1.86
    },
    31: {
      lessThan65: 1.91,
      greaterThan65: 1.84
    },
    30.5: {
      lessThan65: 1.89,
      greaterThan65: 1.82
    },
    30: {
      lessThan65: 1.87,
      greaterThan65: 1.81
    },
    29.5: {
      lessThan65: 1.85,
      greaterThan65: 1.79
    },
    29: {
      lessThan65: 1.84,
      greaterThan65: 1.78
    },
    28.5: {
      lessThan65: 1.82,
      greaterThan65: 1.76
    },
    28: {
      lessThan65: 1.8,
      greaterThan65: 1.75
    },
    27.5: {
      lessThan65: 1.78,
      greaterThan65: 1.73
    },
    27: {
      lessThan65: 1.76,
      greaterThan65: 1.71
    },
    26.5: {
      lessThan65: 1.75,
      greaterThan65: 1.7
    },
    26: {
      lessThan65: 1.73,
      greaterThan65: 1.68
    },
    25.5: {
      lessThan65: 1.71,
      greaterThan65: 1.67
    },
    25: {
      lessThan65: 1.69,
      greaterThan65: 1.65
    },
    24.5: {
      lessThan65: 1.67,
      greaterThan65: 1.63
    },
    24: {
      lessThan65: 1.66,
      greaterThan65: 1.62
    },
    23.5: {
      lessThan65: 1.64,
      greaterThan65: 1.6
    },
    23: {
      lessThan65: 1.62,
      greaterThan65: 1.59
    },
    22.5: {
      lessThan65: 1.6,
      greaterThan65: 1.57
    },
    22: {
      lessThan65: 1.58,
      greaterThan65: 1.56
    },
    21.5: {
      lessThan65: 1.57,
      greaterThan65: 1.54
    },
    21: {
      lessThan65: 1.55,
      greaterThan65: 1.52
    },
    20.5: {
      lessThan65: 1.53,
      greaterThan65: 1.51
    },
    20: {
      lessThan65: 1.51,
      greaterThan65: 1.49
    },
    19.5: {
      lessThan65: 1.49,
      greaterThan65: 1.48
    },
    19: {
      lessThan65: 1.48,
      greaterThan65: 1.46
    },
    18.5: {
      lessThan65: 1.46,
      greaterThan65: 1.45
    }
  },
  female: {
    32: {
      lessThan65: 1.84,
      greaterThan65: 1.84
    },
    31.5: {
      lessThan65: 1.83,
      greaterThan65: 1.83
    },
    31: {
      lessThan65: 1.81,
      greaterThan65: 1.81
    },
    30.5: {
      lessThan65: 1.8,
      greaterThan65: 1.79
    },
    30: {
      lessThan65: 1.79,
      greaterThan65: 1.78
    },
    29.5: {
      lessThan65: 1.77,
      greaterThan65: 1.76
    },
    29: {
      lessThan65: 1.76,
      greaterThan65: 1.75
    },
    28.5: {
      lessThan65: 1.75,
      greaterThan65: 1.73
    },
    28: {
      lessThan65: 1.73,
      greaterThan65: 1.71
    },
    27.5: {
      lessThan65: 1.72,
      greaterThan65: 1.7
    },
    27: {
      lessThan65: 1.7,
      greaterThan65: 1.68
    },
    26.5: {
      lessThan65: 1.69,
      greaterThan65: 1.66
    },
    26: {
      lessThan65: 1.68,
      greaterThan65: 1.65
    },
    25.5: {
      lessThan65: 1.66,
      greaterThan65: 1.63
    },
    25: {
      lessThan65: 1.65,
      greaterThan65: 1.61
    },
    24.5: {
      lessThan65: 1.63,
      greaterThan65: 1.6
    },
    24: {
      lessThan65: 1.62,
      greaterThan65: 1.58
    },
    23.5: {
      lessThan65: 1.61,
      greaterThan65: 1.56
    },
    23: {
      lessThan65: 1.59,
      greaterThan65: 1.55
    },
    22.5: {
      lessThan65: 1.58,
      greaterThan65: 1.53
    },
    22: {
      lessThan65: 1.56,
      greaterThan65: 1.52
    },
    21.5: {
      lessThan65: 1.55,
      greaterThan65: 1.5
    },
    21: {
      lessThan65: 1.54,
      greaterThan65: 1.48
    },
    20.5: {
      lessThan65: 1.52,
      greaterThan65: 1.47
    },
    20: {
      lessThan65: 1.51,
      greaterThan65: 1.45
    },
    19.5: {
      lessThan65: 1.5,
      greaterThan65: 1.44
    },
    19: {
      lessThan65: 1.48,
      greaterThan65: 1.42
    },
    18.5: {
      lessThan65: 1.47,
      greaterThan65: 1.4
    }
  }
};

//function to estimate height
export const getULNA_height = (
  ulnaLength: number,
  gender: 'male' | 'female',
  age: number
) => {
  const data = ulnaData[gender];
  if (!data) return 'Invalid gender.';

  //sorted array of ulna lengths
  const ulnaLengths = Object.keys(data)
    .map(Number)
    .sort((a, b) => a - b);

  //if ulnalength is an exact match, return the corresponding height
  if (data[ulnaLength]) {
    return age < 65
      ? data[ulnaLength].lessThan65
      : data[ulnaLength].greaterThan65;
  }

  //find the two closest ulna lengths
  let lower: number | null = null;
  let upper: number | null = null;

  for (let i = 0; i < ulnaLengths.length; i++) {
    if (ulnaLengths[i] < ulnaLength) {
      lower = ulnaLengths[i];
    } else if (ulnaLengths[i] > ulnaLength) {
      upper = ulnaLengths[i];
      break; //break since we found the range
    }
  }

  //if no valid range found
  if (lower === null || upper === null) return 'Invalid ulna length.';

  const closest =
    Math.abs(ulnaLength - lower) < Math.abs(ulnaLength - upper) ? lower : upper;
  //return data of closest
  return age < 65 ? data[closest].lessThan65 : data[closest].greaterThan65;
};

//function to get bmi through MUAC
export const getMUAC_BMI = (measurement: number) => {
  return measurement < 23.5
    ? 'BMI likely < 20'
    : measurement > 32
      ? 'BMI likely > 30'
      : 'BMI likely 20-30';
};

// function to get bmi through ULNA
export const getULNA_BMI = (estHeight: number, weight: number) =>
  (weight / (estHeight * estHeight)).toFixed(2);
